import { environment } from "src/environments";

const {
  appIds,
  loginAuthorityPolicyName,
  passwordResetPolicyName,
  tenantName,
} = environment.azureAD;

export const authorityDomain = `${tenantName}.b2clogin.com`;
const rootUrl = `https://${authorityDomain}/tfp/${tenantName}.onmicrosoft.com`;

export const { clientId } = environment.azureAD;
export const authority = `${rootUrl}/${loginAuthorityPolicyName}`;
export const passwordResetAuthority = `${rootUrl}/${passwordResetPolicyName}`;

export function getYMSScopes(scopeNames: string[]): string[] {
  return scopeNames.map(
    (name) => `https://${tenantName}.onmicrosoft.com/${appIds.mr}/${name}`,
  );
}
